import React from 'react';
import TitleML from './TitleML';

export default (props) => <TitleML {...props} />;
